/* Copyright (C) 2020 Carlo Capuano - All Rights Reserved
 * You may use, distribute and modify this code under the
 * terms of the MIT license.
 */
import { Injectable } from '@angular/core';
import { DbClass } from './../autogenerated/model';
// this service takes care of merging data from the backend into the frontend objects
// by doing this all the contents are update instead of re-instanced so than all the control update

@Injectable({
  providedIn: 'root',
})
export class DataMergeService {
  constructor() {}

  public memory: Map<string, DbClass> = new Map<string, DbClass>();

  private isDbClass(data: any): boolean {
    if (data == null) {
      return false;
    }
    if (typeof data !== 'object') {
      return false;
    }
    if (typeof data._id !== 'string') {
      return false;
    }
    if (String(data._id).length === 0) {
      return false;
    }

    return true;
  }

  /**
   * merge object b into a
   */
  private extend(a: any, b: any) {
    Object.keys(b).forEach((key) => {
      a[key] = b[key];
    });
  }

  public parseData(data: any): any {
    let warp = { data };
    warp = this.parseDataInRecursion(warp);
    return warp.data;
  }

  private parseDataInRecursion(data: any): any {
    if (data == null) {
      return data;
    }
    if (typeof data !== 'object') {
      return data;
    }

    // we received a date from server
    if (data.ddate != null) {
      return new Date(Date.parse(data.value));
    }

    Object.keys(data).forEach((key) => {
      let value = data[key];
      // going recursive right on the received value, this should stop recursion
      // if a _id object is represent in parent tree node
      value = this.parseDataInRecursion(value);
      // we replace the value with the parsed one, so dates are set.
      // yet if turn out to be a content we will replace with the one in memory
      data[key] = value;
      if (this.isDbClass(value)) {
        if (this.memory.has(value._id)) {
          // we have it already in memory
          // therefore we extend the one we have in memory with this one
          this.extend(this.memory.get(value._id), value);
          // we replace the new value with the one in memory so we keep references
          data[key] = this.memory.get(value._id);
        } else {
          // welcome to the family
          this.memory.set(value._id, value);
        }
        if (value.id === undefined) {
          value.id = value._id;
        }
      }
    });

    return data;
  }
}
